import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const CHANGED = 'scribelive:branding-changed';

/**
 * The customer logo for this session, shared by the header and the Settings card.
 *
 * `shown` is the nearest logo at or above where the session is working (office →
 * region → organisation → enterprise); `own` is the level this person may change, or
 * null. A change anywhere broadcasts the new answer, so the header updates the moment
 * a logo is uploaded rather than on the next page load.
 */
export function useBranding(enabled = true) {
  const [branding, setBranding] = useState({ shown: null, own: null, loaded: false });

  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    axios
      .get(`${API_URL}/api/v1/branding`)
      .then(({ data }) => { if (alive) setBranding({ ...data, loaded: true }); })
      .catch(() => { if (alive) setBranding((b) => ({ ...b, loaded: true })); });
    const onChange = (e) => setBranding({ ...e.detail, loaded: true });
    window.addEventListener(CHANGED, onChange);
    return () => { alive = false; window.removeEventListener(CHANGED, onChange); };
  }, [enabled]);

  return branding;
}

function broadcast(data) {
  window.dispatchEvent(new CustomEvent(CHANGED, { detail: data }));
  return data;
}

export async function uploadLogo(file) {
  const body = new FormData();
  body.append('file', file);
  const { data } = await axios.put(`${API_URL}/api/v1/branding/logo`, body);
  return broadcast(data);
}

export async function removeLogo() {
  const { data } = await axios.delete(`${API_URL}/api/v1/branding/logo`);
  return broadcast(data);
}
